import { Component, OnInit } from '@angular/core';

import { ImageCroppedEvent } from 'ngx-image-cropper';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService } from 'app/services';

@Component({
  selector: 'app-image-cropper-dialog',
  templateUrl: './image-cropper-dialog.component.html',
  styleUrls: ['./image-cropper-dialog.component.scss'],
})
export class ImageCropperDialogComponent implements OnInit {
  image: any = null;
  imageChangedEvent: any = '';
  croppedImage: any = '';

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService
  ) {}

  ngOnInit() {
    const data = this.dynamicDialogConfig.data;
    if (data && data.file) {
      this.image = data.file;
    }
  }

  closeModal() {
    this.dynamicDialogRef.close({ isSuccess: false });
    this.openProfileInfoDropdown();
  }

  saveImage() {
    this.dynamicDialogRef.close({ isSuccess: true, data: this.croppedImage });
    this.openProfileInfoDropdown();
  }

  openProfileInfoDropdown() {
    this.dataService.sendData(
      this.dataService.typeDialog('cropper-modal', '', null, null, {
        open: true,
      })
    );
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
}
